import React from "react";
import {useSelector} from "react-redux";
import TabsMenu from "../../components/TabsMenu";
import "./style.scss";
import cleveronImg from "../../images/cleveronImg.png";
import BuSpecificHeader from "../../components/Header/BuSpecificHeader";
import {useTranslation} from "react-i18next";
export const CleveronScreen = () => {
  const {t} = useTranslation();
  const {urlLinkSource} = useSelector((state) => {
    return {
      urlLinkSource: state.globalReducer?.urlLinkSource || null,
    };
  });
  const moduleNumber = 1;
  return (
    <div className="cleveron-screen-container">
      {urlLinkSource === "web" ? <BuSpecificHeader /> : null}
      <TabsMenu />
      <div>
        <div className="cleveron-screen-content">
          <div className="is-content-wrap">
            <div className="is-header-text">
              <div className="cleveron-text-1">
                <p>{t("yourPurchaseIs")}</p>
                <div className="is-header-text"></div>
                <p className="text-align-center">{`${t(
                  "inModule"
                )} ${moduleNumber} !`}</p>
              </div>
              <div className="cleveron-text-2">
                <p className="text-align-center">
                  {t("ComeCloserWithYourQRCode")}
                </p>
                <p className="text-align-center">
                  {t("toWithdrawYourPurchase")}
                </p>
              </div>
            </div>
            <img className="cleveron-img" src={cleveronImg} alt="img" />
            <div className="cleveron-footer">
              <div className="is-footer-text">
                <p>{t("cleveronScreenFooter1")}</p>
                <p>{t("cleveronScreenFooter2")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
